<template>
    <div class="shop-item">
        <template v-for="(item, index) in list.slice(0,PreviewNum)">
            <div class="article-cover"
                 v-if="shopType==='store'"
                 :key="index"
                 :id="item.id"
                 :class="{'stall-content': marketplaceActivity}">

                <div class="cover" @click="handleClick(item)">
                    <img :src="item.frontUrl" v-if="item.frontUrl!==''">
                    <img src="@/assets/images/default_banner.svg" v-else>
                    <span class="address" v-if="isShowAddress(item) && !marketplaceActivity">{{item.city}} {{item.township}} {{item.distance}}</span>
                </div>
                <!--todo 識別圖-->
                <div class="identify-block" v-if="!marketplaceActivity">
                    <img :src="couponLogoImage"
                         v-for="(couponLogoImage, index) in item.couponLogoImageList"
                         :key="index"
                         class="identify-logo">
                </div>
                <div class="intro-con">
                    <h2 class="brand">{{item.brandName}}<span class="ml-3">{{item.name}}</span></h2>
                    <div class="info-line" v-if="!marketplaceActivity">
                        <div v-if="isShowPriceRange(item) && !hidePrice" class="fee">
                            <img src="@/assets/images/coin_gray.svg" alt="低消">
                            <span>{{item.priceRange}}</span>
                        </div>
                        <div class="evaluate" v-if="isShowStar(item) && !hideStar">
                            <img src="@/assets/images/smile.svg" alt="評價">
                            <span>{{item.star}}</span>
                        </div>
                    </div>
                    <!--todo 外送資訊-->
                    <div class="takeout-list" v-show="showRemark(item)&&!marketplaceActivity" @click.stop="isOpen(index)">
                        <div class="title">
                            <div v-if="!isNoteIconError">
                                <img :src="isNoteIconEmpty(item.noteIcon) ? require('@/assets/images/remark/remark_'+item.noteIcon+'.svg'):''" @error="onImgError"/>{{item.title}}：
                            </div>
                            <div v-else>
                                <img :src="require('@/assets/images/remark/remark_01.svg')"/>{{item.title}}：
                            </div>
                        </div>
                        <div class="con" v-html="remark(item)"/>

                        <div class="icon-arrow">
                            <i class="el-icon-arrow-right"/>
                        </div>
                    </div>
                    <!-- 將item屬性傳給父元件， "item"表示要傳遞的內部屬性， :item表示要給父元件呼叫的屬性名稱 -->
                    <slot :item="item"/>
                </div>
            </div>
            <div class="article-cover"
                 v-if="shopType==='brand'"
                 :key="index"
                 :param="{type: 'brand'}"
                 :id="item.brandId">

                <div class="cover" @click="handleClick(item)">
                    <img :src="item.imagePath" v-if="item.imagePath!==''">
                    <img src="@/assets/images/default_banner.svg" v-else>
                </div>
                <h2 class="brand">{{item.brandName}}</h2>
                <slot/>
            </div>
        </template>
        <comm-dialog :value="isShowLogin"
                     :outerContent="'請先登入'"
                     @result="onShowLoginDialogClose"/>
    </div>
</template>

<script>
    import CommDialog from "@/components/CommDialog.vue";
    import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";

    export default {
        name: "ArticleCover",
        components: {CommDialog},
        props: {
            imgUrl:{},
            id:{},
            param:{},
            list:{},
            showRemark:{},
            remark:{} ,
            shopType:{default: 'store'},//區別店家或品牌'brand'
            marketplaceActivity: Boolean, //商圈活動的店家使用
            hidePrice: Boolean,     //強制隱藏價位區間
            hideStar: Boolean,     //強制隱藏評價
            PreviewNum:{}, //預覽時抓取的筆數
            actionType:{},
        },
        watch: {
            list() {

            }
        },
        data() {
            return {
                type: typeof this.param === 'undefined' || typeof this.param.type === 'undefined' ? 'store' : this.param.type,
                // isShowAddress: typeof this.param === 'undefined' || typeof this.param.isShowAddress === 'undefined' ? 'true' : this.param.isShowAddress
                //載圖錯誤旗標
                isNoteIconError: false,

                //請先登入彈框
                isShowLogin: false,

                encryptUrlSegment:'',           //預約訂位用的加密參數
                userId:'',
            }
        },
        methods: {

            /** 是否顯示地址？ 只要有 isShowAddress並爲 true，而且city, township, distance其中有一個不是空白  */
            isShowAddress: function(item) {
                let result = this.$public.notNull(item) && //this.$public.notNull(this.param) &&
                    //this.$public.notNull(this.param.isShowAddress) && this.param.isShowAddress &&
                    ((this.$public.notNull(item.city) && item.city !== '') ||
                    (this.$public.notNull(item.township) && item.township !== '') ||
                    (this.$public.notNull(item.distance) && item.distance !== '')) ;

                return result;
            },

            handleClick(item) {
                if (this.$public.notNull(item.vendorId) && item.vendorId>0) {
                    //攤販
                    let dataToken = this.cryptDataToken({"id": item.vendorId});
                    this.$router.push({name: 'StallInfo', query: {"dataToken": dataToken}});

                } else {
                    if (this.shopType === 'store') {
                        //商店
                        if (this.$public.notNull(item.id) && item.id > 0) {
                            if (this.actionType && this.actionType !== '') {
                                if (!this.$auth.isAdminLogin(true)) {
                                    this.isShowLogin = true
                                } else if (this.actionType === 'OrderList') {
                                    this.$router.push({name: this.actionType, query:{id: item.id}});
                                } else if (this.actionType === 'Booking') {
                                    this.combineBookingParams();
                                    this.loadBooking(item.bookingUrl);
                                }
                            } else {
                                this.$router.push({name: 'StoreInfo', query: {"id": item.id}});
                            }
                        }

                    } else if (this.shopType === 'brand') {
                        //品牌
                        if (this.$public.notNull(item.brandId) && item.brandId > 0) {
                            this.$router.push({name: 'BrandInfo', query: {"id": item.brandId}});
                        }
                    }
                }
            },

            /** 是否顯示備註 */
            // isShowRemark: function(item) {
            //     let result = false;
            //     if (this.$public.notNull(item) && this.$public.notNull(item.noteStatus)) {
            //         result = item.noteStatus &&
            //             (this.$public.notNull(item.title) && item.title !== '') &&
            //             (this.$public.notNull(item.noteAry)) &&
            //             item.noteAry.length > 0;
            //     }
            //     return result ;
            // },

            /** 是否顯示價位區間 */
            isShowPriceRange(item) {
                // return (this.$public.notNull(item) && this.$public.notNull(item.priceRange)) &&
                //         (item.priceRange !== '$0~$0');
                let isShow = (this.$public.notNull(item) && this.$public.notNull(item.priceRange)) &&
                                this.$public.notNull(item.priceStatus) && item.priceStatus;

                return isShow;
            },

            /** 是否顯示評價 */
            isShowStar(item) {
                return (this.$public.notNull(item) && this.$public.notNull(item.star)) && (item.star !== '0.0');
            },

            /** 外送詳細開合 */
            isOpen(id) {
                document.getElementsByClassName('takeout-list')[id].classList.toggle("open")
            },

            /** icon是否爲空？ */
            isNoteIconEmpty: function(noteIcon) {
                return (this.$public.notNull(noteIcon) && noteIcon !== '');
            },

            /** 載圖錯誤 */
            onImgError: function() {
                this.isNoteIconError = true;
            },

            /** 組裝 dataToken */
            cryptDataToken: function(item) {
                return this.$crypto.objectToURIComponent(item) ;
            },

            /** 解析 dataToken */
            decryptDataToken: function(item) {
                return this.$crypto.uriComponentToObject(item);
            },

            onShowLoginDialogClose(result){
                this.isShowLogin = false
                if (result) {
                    this.$router.push({name: 'Login'});
                }
            },

            /** 產生訂候位用的參數 */
            combineBookingParams : function() {
                let self = this;
                let usertoken = localStorage.getItem("admin_token");
                let decrypted = self.$crypto.decryptText(usertoken);
                let decrypted_array = decrypted.split(';');

                // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                const userData = getCryptoUserInfo();
                let user_name = userData.name;
                let phone = userData.phone;
                let gender = userData.gender;
                let email = userData.email;


                let encryptString = user_name+";"+phone+";"+gender+";"+email+";"+decrypted_array[0];
                let encryptedString = self.$crypto.encryptText(encryptString);
                let secondEncrypt = encodeURIComponent(encryptedString);
                self.encryptUrlSegment = secondEncrypt;
                self.userId = decrypted_array[0];
            },

            /** 開啓訂位網頁 */
            loadBooking:function(bookingUrl){
                let urlSet = bookingUrl+"/"+this.encryptUrlSegment;


                let self = this;
                let browser = this.$public.isCordova()? window.cordova.InAppBrowser: window;
                //使用 _system的話會呼叫 app外部的 browser來開網頁
                let appInBrowser = browser.open(urlSet, '_blank', 'toolbar=no,location=no' + self.$http.browserOpenFeatures());

                // 注意，這一段是針對使用 InAppBrowser這個套件專用的方法
                //如果是 cordova開啓，就植入 javascript持續取得網頁網址 location.href，
                //直到轉成訂位成功的頁面，再將另一段 javascript植入加入行事曆按鈕中，發射 message給 app接收
                if (this.$public.isCordova()) {

                    if (this.$public.notNull(appInBrowser)) {
                        let loop = null;

                        appInBrowser.addEventListener('message', function(...args) {

                            if (self.$public.notNull(args) && self.$public.notNull(args[0])) {
                                let msgObj = args[0];
                                if (msgObj.type === 'message') {
                                    if (self.$public.notNull(msgObj.data) &&
                                        self.$public.notNull(msgObj.data.message)){

                                        if (msgObj.data.message.indexOf('booking-confirm') >= 0) {
                                            //加入到行事曆
                                            if (self.$public.notNull(self.storeInfo)) {
                                                self.onBookingCompleted(msgObj.data.message, self.storeInfo.brandName);
                                            }
                                            appInBrowser.close();

                                        } else if (msgObj.data.message.indexOf('close') >= 0) {
                                            appInBrowser.close();
                                        }
                                    }
                                }
                            }
                        }, false);

                        //監聽 '載入完成' 事件
                        appInBrowser.addEventListener('loadstop', function(event) {
                            //取得訂位網頁左上角的'關閉'按鈕，並植入關閉的方式
                            appInBrowser.executeScript({
                                code: "document.getElementById('closeBtn').addEventListener(\"click\",function(e){" +
                                    "const message = {message: 'close'};" +
                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(message));" +
                                    "},false);"
                            });

                            //setInterval，會一直取得網頁位址，直到位址內有 booking-confirm才會停止
                            loop = setInterval(function() {

                                appInBrowser.executeScript(
                                    {
                                        //此寫法表示，把 location.href傳給 function( values )，注意 values爲陣列
                                        code: "location.href;"
                                    },
                                    function( values ) {

                                        //植入另一段 javascript
                                        if (self.$public.notNull(values) && self.$public.notNull(values[0]) &&
                                            values[0].indexOf('booking-confirm') >= 0) {

                                            //停止迴圈
                                            clearInterval( loop );

                                            //尋找 id爲 addCalender的元件(前端要先寫好)，植入按下按鈕要觸發的動作
                                            //按下後會傳回目前網頁位址，以 message的形式發送給 inAppBrowser套件
                                            appInBrowser.executeScript({
                                                code:
                                                    "document.getElementById('addCalender').addEventListener(\"click\",function(e){" +
                                                    "const messageObj = { message: location.href};" +
                                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(messageObj));" +
                                                    "}, false);"+
                                                    "document.getElementById('closeBtn').addEventListener(\"click\",function(e){" +
                                                    "const message = {message: 'close'};" +
                                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({message}));" +
                                                    "},false);"
                                            });
                                        }
                                    }
                                );
                            }, 1000);

                        }, true);
                    }
                }

                // self.onBookingCompleted('https://booking-test.oinapp.com/app/39/booking-confirm?id=OKZRa5Hhec1J8j4kpptQLJpnWX4%3D&store=健康旗艦店&date=2021-11-28&time=18%3A00&result=success');
            },

            /** 訂位完成時 */
            onBookingCompleted: function (params, brandName) {
                //訂位完成後會跳到 http://xxx.xxx:8082/app/booking-confirm?id=paFW43Obqq%2BNmahwWtXCWTDyH0A%3D&store=Gottone%20%E8%94%AC%E9%A3%9F&date=2021-11-17&time=12%3A30&result=success
                let success = false;
                let date = '', storeName = '';
                let year = 0, month = 0, day = 0, hour = 0, minute = 0;


                if (this.$public.notNull(params) && params.indexOf('booking-confirm') >= 0) {
                    let decodeUrl = decodeURIComponent(params);

                    decodeUrl.split('&').forEach(
                        //解析網址
                        element => {
                            if (element.indexOf('result=') >= 0) {
                                success = element.indexOf('success') >= 0;

                            } else if (element.indexOf('date=') >= 0) {
                                date = element.substr(element.indexOf('date=')+5);

                                let bookingDate = new Date(date);
                                year = bookingDate.getFullYear();
                                month = bookingDate.getMonth();
                                day = bookingDate.getDate();

                            } else if (element.indexOf('time=') >= 0) {
                                let time = element.substr(element.indexOf('time=')+5);
                                let timeSplit = time.split(':');
                                if (this.$public.notNull(timeSplit)) {
                                    hour = Number(timeSplit[0]);
                                    minute = Number(timeSplit[1]);
                                }

                            } else if (element.indexOf('store=') >= 0) {
                                storeName = element.substr(element.indexOf('store=')+6);
                            }
                        }
                    )
                }

                if (success) {
                    //加入行事曆
                    this.$public.addCalendarEvent(this.$http.getOS(), `${brandName} ${storeName} 訂位`, year, month, day, hour, minute);

                } else {
                    alert("無法將訂位行程加入行事曆");
                }

            },
        }
    }
</script>

<style lang="less" scoped>
    .article-cover {
        margin: 0 20px 20px;
        padding: 12px;
        border-radius: 16px;
        box-shadow: var(--box-shadow);
        background: #fff;
        position: relative;
        @media(min-width: 1024px){
            width: 315px;
            margin: 0 0 20px 20px;
            cursor: pointer;
            &:hover{
                opacity: .7;
            }
        }
        //識別圖
        .identify-block {
            margin: 0 10px;
            position: absolute;
            top: 20px;
        }
        .cover {
            width: 100%;
            height: calc((100vw - 64px) * 0.59);
            max-height: 578px;
            background: #F6F5F4;
            border: 1px solid var(--color-gray);
            position: relative;
            border-radius: 12px;
            overflow: hidden;
            @media(min-width: 1024px){
                height: calc((315px - 24px) * 0.59);
            }
            .address {
                position: absolute;
                padding: 2px 8px;
                color: #fff;
                background: rgba(0, 0, 0, 0.7);
                border-radius: 50px;
                right: 5px;
                bottom: 5px;
                font-size: 12px;
                line-height: 20px;
            }
            img {
                object-fit: cover;
                height: 100%;
            }
        }
        .info {
            width: 100%;
        }
        h2.brand{
            margin-bottom: 0;
        }
        //低消評價
        .info-line {
            display: flex;
            font-size: 14px;
            line-height: 1.5em;
            margin-top: 5px;
            color: #B9B09F;
            img {
                width: 15px;
                margin-right: 5px;
                vertical-align: -6%;
            }
            //低消
            .fee {
                flex: 1;
            }
            //評價
            .evaluate {
                text-align: right;
                margin-left: 20px;
            }
        }
        //攤販小列表使用
        &.stall-content{
            box-shadow: none;
            padding: 0;
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            .cover {
                width: 130px;
                height: 85px;
                margin-right: 10px;
                border-radius: 10px;
            }
            .icons{
                display: flex;
                margin-top: 5px;
            }
            .intro-con{
                flex: 1;
                h2.brand{
                    margin: 0 0 5px;
                    font-size: 14px;
                    line-height: 16px;
                }
                .stall-num{
                    color: #595757;
                    font-size: 12px;
                    margin-left: 2px;
                    line-height: 28px;
                    height: 28px;
                    min-width: 40px;
                    img{
                        width: 13px;
                        vertical-align: -2%;
                        margin-right: 6px;
                    }
                    &+.store-phone-btn{
                        margin-left: 10px;
                    }
                }
            }
        }
        .el-button+.el-button {
            margin-left: 5px;
            /deep/.hasText{
                h1{
                    display: none;
                }
            }
        }
    }
</style>
